export type OnlineCourse = 'core_training' | 'legs_glutes' | 'both' | 'not_yet' | 'other';
export type TrainingLevel = 'beginner' | 'intermediate' | 'advanced' | 'very_advanced';
export type AnamneseTrainingLevel = TrainingLevel | 'other';
export type TrainingLocation = 'full_gym' | 'home_condo_gym';
export type MainGoal = 'weight_loss' | 'muscle_definition' | 'hypertrophy' | 'health_maintenance';
export type ReferralSource = 'referral' | 'social_media' | 'other';

export interface SignUpProfileFormData {
  name: string;
  username: string;
  email: string;
  password: string;
  confirmPassword: string;
  cpf: string;
  birthDate: string;
  callingCode: string;
  phone: string;
  cep: string;
  street: string;
  number: string;
  complement: string;
  neighborhood: string;
  state: string;
  city: string;
  country: string;
  joinedAt: string;
  instagram: string;
  height: string;
  weight: string;
  coachId: string;
}

export interface AnamneseFormData {
  heightCm: string;
  weightKg: string;
  profession: string;
  instagram: string;
  onlineCourse: OnlineCourse | '';
  otherCourse: string;
  previousOnlineConsultancy: string;
  courseFeedback: string;
  trainingLevel: AnamneseTrainingLevel | '';
  trainingLevelOther: string;
  trainingLocation: TrainingLocation | '';
  availableEquipment: string;
  fullGymName: string;
  weeklyAvailability: string;
  availableTrainingTime: string;
  hadInjury: boolean | null;
  injuryDescription: string;
  hasPain: boolean | null;
  painLocation: string;
  painLimitsTraining: boolean | null;
  limitedExercises: string;
  currentlyExercises: boolean | null;
  exerciseModalities: string;
  timeWithoutExercise: string;
  exerciseHistory: string;
  enjoysTraining: boolean | null;
  usedToEffort: boolean | null;
  hasNutritionalSupport: boolean | null;
  dietDetail: string;
  takesMedication: boolean | null;
  medications: string;
  hadSurgery: boolean | null;
  surgeries: string;
  hasChronicDisease: boolean | null;
  chronicDiseases: string;
  hasFamilyHistory: boolean | null;
  familyHistoryDescription: string;
  hasChildren: boolean | null;
  timeSinceDelivery: string;
  abdominalDiastasis: boolean | null;
  diastasisTreatment: string;
  mainGoal: MainGoal | '';
  goalDetails: string;
  additionalInfo: string;
  referralSource: ReferralSource | '';
  motivation: string;
}

export interface ParQFormData {
  heartCondition: boolean | null;
  heartConditionOther: string;
  chestPainActivity: boolean | null;
  chestPainRecent: boolean | null;
  dizziness: boolean | null;
  boneJointProblem: boolean | null;
  takesBpMedication: boolean | null;
  otherReason: boolean | null;
  responsibility: string;
}

export interface PhotoFile {
  preview: string;
  file?: File;
  stored?: boolean;
}

export interface PhotosFormData {
  front: PhotoFile | null;
  back: PhotoFile | null;
  rightSide: PhotoFile | null;
  leftSide: PhotoFile | null;
}

export interface OnboardingState {
  userId: string | null;
  studentId: number | null;
}

export const ONLINE_COURSE_OPTIONS = [
  { value: 'core_training', label: 'Core Training' },
  { value: 'legs_glutes', label: 'Pernas e Glúteos' },
  { value: 'both', label: 'Ambos' },
  { value: 'not_yet', label: 'Ainda não' },
  { value: 'other', label: 'Outro' },
] as const;

export const TRAINING_LEVEL_OPTIONS: Array<{ value: AnamneseTrainingLevel; label: string }> = [
  { value: 'beginner', label: 'Iniciante' },
  { value: 'intermediate', label: 'Intermediário' },
  { value: 'advanced', label: 'Avançado' },
  { value: 'very_advanced', label: 'Muito Avançado' },
  { value: 'other', label: 'Outro' },
];

export const TRAINING_LOCATION_OPTIONS = [
  { value: 'full_gym', label: 'Academia completa' },
  { value: 'home_condo_gym', label: 'Casa / Academia do condomínio' },
] as const;

export const MAIN_GOAL_OPTIONS = [
  { value: 'weight_loss', label: 'Emagrecimento' },
  { value: 'muscle_definition', label: 'Definição muscular' },
  { value: 'hypertrophy', label: 'Hipertrofia' },
  { value: 'health_maintenance', label: 'Manutenção da saúde / reabilitação' },
] as const;

export const REFERRAL_SOURCE_OPTIONS = [
  { value: 'referral', label: 'Indicação' },
  { value: 'social_media', label: 'Redes sociais' },
  { value: 'other', label: 'Outro' },
] as const;
